<template>
  <div>
    <div class="flex min-h-screen max-h-screen flex-col">
      <div class="flex mx-auto p-4 w-full justify-center">
        <p>{{ $t("index.navigate") }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { ROUTE_BODYPRINT_QUEUE, ROUTE_PRODUCTION } from "@/router";

export default {
  name: "Index",
  computed: {
    ...mapGetters({
      getAuth: "auth/getAuth"
    })
  },
  data() {
    return {};
  },
  mounted() {
    this.$store.dispatch("layout/toggleSidebar");

    if (
      this.getAuth.bodyprintQueue ||
      this.getAuth.bodyprintSearch ||
      this.getAuth.bodyprintList
    ) {
      this.$router.replace({ name: ROUTE_BODYPRINT_QUEUE });
    } else if (this.getAuth.productionOrders) {
      this.$router.replace({ name: ROUTE_PRODUCTION });
    }
  }
};
</script>
